module.exports = __webpack_public_path__ + "static/media/snowflake.8b1479ab.svg";